import { Alert } from "@material-ui/lab";
import React from "react";
import { useHistory } from "react-router";
import { AlertContainer, ButtonAlert } from "./styles";

export function ErrorMessage(data) {
  return (
    <Alert variant="outlined" severity="error" style={{ marginBottom: 10 }}>
      Erro ao criar novo contato:
      {data && Array.isArray(data) && (
        <ul style={{ margin: 10 }}>
          {data.map((message) => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      )}
    </Alert>
  );
}

export function MyContactAlreadyExists({ id }) {
  const history = useHistory();

  return (
    <AlertContainer>
      <p>O contato que você está tentando criar já existe.</p>

      <ButtonAlert
        fullWidth
        color="primary"
        variant="contained"
        onClick={() => history.push(`/app/chat/${id}`)}
      >
        Ir para o contato
      </ButtonAlert>
    </AlertContainer>
  );
}

export function ContactWithOtherUser({ owner_name }) {
  return (
    <AlertContainer>
      <p>
        Criar este contato não é possível, pois já foi criado anteriormente e
        está em atendimento com <b>{owner_name}</b>
      </p>

      <br />
      <br />
    </AlertContainer>
  );
}
